import React from "react";

import "./Checkbox.scss";

export type CheckboxProps = {
  cx?: string;
  label: string | React.ReactElement;
  defaultChecked?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  forwardRef?: React.LegacyRef<HTMLInputElement>;
};

export const Checkbox: React.FC<CheckboxProps> = ({
  cx = "",
  label,
  defaultChecked = false,
  onChange,
  forwardRef,
}) => {
  return (
    <label className={`Checkbox ${cx}`}>
      <input
        type={"checkbox"}
        defaultChecked={defaultChecked}
        onChange={onChange}
        ref={forwardRef}
      />
      <div className={"checkbox-wrapper"}>
        <div className={"square"}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path
              d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"
              stroke="black"
              strokeLinejoin={"round"}
            />
          </svg>
        </div>
        <span>{label}</span>
      </div>
    </label>
  );
};
